import {fetchUserEventCreate} from '@blesk-frontend/api';
import {bleskAuthStore} from '@blesk-frontend/auth';
import {useEffect} from 'react';

export const useEvents = () => {
  const {token, teamId, isAdmin} = bleskAuthStore();

  useEffect(() => {
    if (!isAdmin && token && teamId) {
      fetchUserEventCreate({
        type: 'last-seen',
        payload: {teamId, timestamp: new Date()},
      });
    }
  }, [teamId, isAdmin, token]);
};
